var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrogrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-22.9199,-1400.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,-638.978,-301.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microgrid",
    transform: "matrix(1,0,0,1,-13.5829,4.76107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.779907,0,0,0.437787,290.263,325.974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 529.35,
    cy: 1399.56,
    r: 75.164,
    style: {
      fill: "rgb(96,125,139)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.353357,0,0,0.209305,299.432,830.984)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36273,0.350747,-0.231135,0.413974,784.081,-301.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "9.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.375161,0.3388,-0.433555,-0.224816,1937.63,119.548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "9.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.518077,-0.0118281,-0.138822,-0.449494,1949.72,748.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "9.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0124814,0.490964,-0.474318,0.131556,1459.41,-317.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "9.33px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.163925,0.410134,-0.345402,0.260701,1132.67,-286.834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "10.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.434716,0.150341,-0.269416,-0.331003,1916.52,448.647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "10.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419008,-0.185219,0.0564229,-0.415137,1688.49,968.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "10.45px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.195773,0.397834,-0.437435,-0.0529715,1690.79,-71.2389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1464.29,568.287",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "10.45px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5196,0,0,0.476593,418.741,146.981)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1391.76,
    cy: 630.663,
    r: 50.977,
    style: {
      fill: "white",
      stroke: "rgb(96,125,139)",
      strokeWidth: "10.55px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.130268,0,0,0.0731235,521.593,876.448)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-29.2681,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.462419,-0.800934,-0.800934,-0.462419,1287.59,2114.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1234.53,590.363C1224.83,630.099 1217.58,674.085 1211.55,720.167C1212.21,730.754 1215.19,738.365 1221.56,741.627C1230.81,738.827 1239.61,739.189 1248.1,741.76C1254.27,736.762 1257.49,729.625 1257.52,720.167C1250.99,674.414 1244.06,629.516 1234.53,590.363Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.80685,0,1.89737e-17,0.80685,231.356,144.012)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1246.62,
    cy: 774.79,
    r: 22.986,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.462419,0.800934,0.800934,-0.462419,42.4188,137.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1234.53,590.363C1224.83,630.099 1217.58,674.085 1211.55,720.167C1212.21,730.754 1215.19,738.365 1221.56,741.627C1230.81,738.827 1239.61,739.189 1248.1,741.76C1254.27,736.762 1257.49,729.625 1257.52,720.167C1250.99,674.414 1244.06,629.516 1234.53,590.363Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.924839,-1.94289e-16,-1.94289e-16,0.924839,2378.94,52.2826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1234.53,590.363C1224.83,630.099 1217.58,674.085 1211.55,720.167C1212.21,730.754 1215.19,738.365 1221.56,741.627C1230.81,738.827 1239.61,739.189 1248.1,741.76C1254.27,736.762 1257.49,729.625 1257.52,720.167C1250.99,674.414 1244.06,629.516 1234.53,590.363Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.40661,0,0,5.39257,-1912.26,-918.731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.546,375.904L718.898,375.863L718.921,375.814L717.418,319.104C715.564,319.873 713.216,319.821 711.524,319.15M709.546,375.904L711.524,319.15",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.46881,0,0,5.46881,-2664.23,-955.017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.72,376.778L724.302,377",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.68px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.986691,-0.0130792,-0.0130792,0.987147,34.7485,34.1488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1654.22,904.11L1688.91,938.201",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "15.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.2022,0,0,6.2022,887.269,-8213.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.73,1465.48C95.296,1465.33 94.536,1463.22 94.839,1461.39L97.119,1442.18C97.271,1440.72 98.172,1440.44 99.897,1440.44L120.881,1440.44C122.519,1440.45 123.07,1440.62 123.317,1442.11L126.324,1461.68C126.602,1463.48 126.366,1465.02 125.233,1465.48L114.227,1465.48",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.20166,0.0818385,-0.0818385,6.20166,1006.23,-8221.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.475,1440.44L105.325,1465.48",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.1795,0.530133,-0.530133,-6.1795,3027.16,9720.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.475,1440.44L105.325,1465.48",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.2022,0,0,6.2022,887.269,-8213.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.296,1457.36L125.535,1457.38",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.2022,0,0,6.2022,887.269,-8213.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.103,1469.91L114.227,1469.94L114.227,1465.48L107.051,1465.48L107.103,1469.91Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.2022,0,0,6.2022,887.269,-8213.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.051,1465.48L96.73,1465.48",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.2022,0.00447207,-0.00447207,-6.2022,2262.39,9753.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.303,1448.53L96.368,1448.51",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.36px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1321.73,1107.91L1320.13,937.39L1408.63,856.877L1451.71,857.016L1408.63,856.877L1501.46,938.029L1502.71,1107.91L1321.73,1107.91Z",
    style: {
      fill: "rgb(96,125,139)",
      stroke: "white",
      strokeWidth: "14.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.45,1107.91L1687.88,1108.19L1688.91,938.201L1509.7,941.194",
    style: {
      fill: "rgb(96,125,139)",
      stroke: "white",
      strokeWidth: "14.63px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18627e-16,-1.93733,1.93733,1.18627e-16,-558.256,3745.63)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.12636e-16,3.47262,-5.46881,3.34868e-16,2767.52,-631.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.947,
    y: 242.063,
    width: 12.336,
    height: 11.953,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "1.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.10428e-17,1.32353,-2.95989,1.81241e-16,2170.4,386.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.947,
    y: 242.063,
    width: 12.336,
    height: 11.953,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "3.29px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.37907,48.9275)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.1355,5.46813,-8.63526,-0.0858029,3508.58,-1622.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.576,232.493L471.664,238.142",
    style: {
      fill: "none",
      stroke: "rgb(96,125,139)",
      strokeWidth: "4.02px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.46813,0.1355,-0.0858029,8.63526,-1146.03,-1159.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.576,232.493L471.664,238.142",
    style: {
      fill: "none",
      stroke: "rgb(96,125,139)",
      strokeWidth: "4.02px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.1355,5.46813,-8.63526,-0.0858029,3504.21,-1505.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.576,232.493L471.664,238.142",
    style: {
      fill: "none",
      stroke: "rgb(96,125,139)",
      strokeWidth: "4.02px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.47775,0,0,12.9559,-7833.48,-4661.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 993.21,
    y: 438.754,
    width: 3.686,
    height: 5.702,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "2.58px"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrogrid);
export default __webpack_public_path__ + "static/media/microgrid.93cc718f23e0e2b76d90cf01d014e772.svg";
export { ForwardRef as ReactComponent };